export class SammelbestellerFilter{

  public sammelbesteller: Object
  public apiZeitraum: { von: '', bis: '' }
  public filterDatum: Date | any
  public essensteilnehmer = {}

  constructor() {}
}
